import React from 'react';
import cn from 'classnames';

import { useSiteMetaData } from '../util/queries/site';
import { useSettings } from '../util/queries/settings';

import LinkedinIcon from './icons/Linkedin';
import EmailIcon from './icons/Email';
import TwitterIcon from './icons/Twitter';
import WhatsappIcon from './icons/Whatsapp';

import * as styles from './Share.module.css';
import { externalLink } from '../util';

const Share = ({ className, url, style, alignTo = 'left' }) => {
  const { siteUrl } = useSiteMetaData();
  const { share } = useSettings();

  const shareUrl = `${siteUrl}/${url}`;

  const buildUrl = (baseUrl, params) => {
    // Convert params to URL safe query string
    const queryString = Object.keys(params)
      .map(
        key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join('&');

    return `${baseUrl}?${queryString}`;
  };

  const trackEvent = type => {
    const [path, section = 'issue'] = url.split('#');
    const evt = {
      event: `share.${type}`,
      path,
      section
    };
    window.dataLayer && window.dataLayer.push(evt);
  };

  const shareLinks = [
    {
      url: buildUrl('https://www.linkedin.com/sharing/share-offsite/', {
        url: shareUrl
      }),
      icon: <LinkedinIcon className={cn(styles.shareIcon)} />,
      ...externalLink,
      label: share.linkedin.label,
      type: 'linkedin'
    },
    {
      url: `mailto:?subject=${share.email.subject}&body=${share.email.text} \b${shareUrl}`,
      icon: <EmailIcon className={cn(styles.shareIcon)} />,
      ...externalLink,
      label: share.email.label,
      type: 'email'
    },
    {
      url: buildUrl('https://twitter.com/intent/tweet', {
        text: `${share.twitter.text} ${shareUrl}`
      }),
      icon: <TwitterIcon className={cn(styles.shareIcon)} />,
      ...externalLink,
      label: share.twitter.label,
      type: 'twitter'
    },
    {
      url: `whatsapp://send?text=${share.whatsapp.text} ${shareUrl}`,
      icon: <WhatsappIcon className={cn(styles.shareIcon)} />,
      ...externalLink,
      label: share.whatsapp.label,
      type: 'whatsapp'
    }
  ];

  const cssClasses = cn(styles.root, className, {
    [styles.alignToRight]: alignTo === 'right'
  });

  return (
    <ul className={cssClasses} style={style}>
      {shareLinks.map(({ label, icon, url, target, rel, type }, index) => (
        <li key={index}>
          <a
            href={url}
            target={target}
            rel={rel}
            title={label}
            onClick={() => trackEvent(type)}
            className={cn(styles.shareLink)}
          >
            {icon}
            <span className={cn(styles.shareText)}>{label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Share;
